export const version = '2.14.15';
//# sourceMappingURL=version.js.map